"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Box_1 = require("./Box");
const FairIcon = (props) => {
    const svgStyle = Object.assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" });
    return (React.createElement(Box_1.Box, Object.assign({ position: "relative", width: 18, height: 18 }, props),
        React.createElement("svg", { viewBox: "0 0 18 18", style: svgStyle, fill: "currentColor" },
            React.createElement("path", { d: "M9.533 7.02702H14V14H15V15H3V14H4V7.02702H8.467V1.37602L12.733 3.66602L9.533 5.21602V7.02702ZM8 14V10.92H10.074V14H13V8.02702H5V14H8Z" }))));
};
FairIcon.displayName = 'FairIcon';
exports.default = FairIcon;
//# sourceMappingURL=FairIcon.js.map